// Simple, safe deep clone with runtime fallback
export function deepClone<T>(obj: T): T {
  const g: any = globalThis as any;
  if (typeof g.structuredClone === 'function') {
    return g.structuredClone(obj);
  }
  // Fallback: fine for plain data (objects/arrays/strings/numbers)
  return JSON.parse(JSON.stringify(obj));
}
